export const SPORT_PRODUCT = [
  {
    order: true,
    id: 244076767,
    title: "Профессиональные взрослые ролики",
    img: "f3a392a0-9695-41c1-9895-084b1f7b477e-Photoroom.png",
    desc: "45-46",
    category: "roller",
    price: 290,
    column: [
      "Профессиональные роликовые коньки унисекс. Идеальный выбор для начинающих мужчин и женщин. Удобная, регулируемая тренировочная обувь со съёмной внутренней частью и прочными колёсами.",
      "Материал подошвы: ПВХ",
      "Тип застёжки: Двойная пряжка",
    ],
  },
  {
    order: true,
    id: 1244076767,
    title: "Ролики взрослые ZSD-1",
    img: "2726be67-fd77-4b23-abd1.png",
    desc: "белые, черно-белые, черные ",
    category: "roller",
    price: 270,
    column: [
      "Профессиональные роликовые коньки классического стиля.",
      "Однотонный универсальный дизайн — подходит для любого сезона.",
      "Застёжка и шнуровка обеспечивают надёжную фиксацию стопы.",
      "Дизайн с обёртыванием для плотного и комфортного прилегания.",
      "Подходят для спортивных тренировок, активного отдыха и катания.",
      "Удобны для мужчин и женщин.",
    ],
  },
  {
    order: true,
    id: 12440767678,
    title: "Ролики взрослые ZSD-1",
    img: "9b748ca8-550b-4653-bf5b-a16d9981e097.webp",
    desc: "белые, черно-белые, черные ",
    category: "roller",
    price: 270,
    column: [
      "Профессиональные роликовые коньки классического стиля.",
      "Однотонный универсальный дизайн — подходит для любого сезона.",
      "Застёжка и шнуровка обеспечивают надёжную фиксацию стопы.",
      "Дизайн с обёртыванием для плотного и комфортного прилегания.",
      "Подходят для спортивных тренировок, активного отдыха и катания.",
      "Удобны для мужчин и женщин.",
    ],
  },
  {
    order: true,
    id: 124407676734,
    title: "Ролики",
    img: "S26c662a36c034fac90.png",
    desc: "43 размер",
    category: "roller",
    price: 350,
    column: [
      "Колёса: 3×110 мм или 3×125 мм из PU (с подсветкой или без).",
      "Рама: равноудалённая R5 110/125 мм, изготовлена методом ЧПУ.",
      "Подходят для фристайла, марафонов, скоростного катания и тренировок.",
    ],
  },
  {
    order: true,
    id: 12440767673124,
    title: "Юношеские ролики с тормозами",
    img: "du71fbs6s55jawrupgbdmb67firtfjxf.jpg",
    desc: "S(28-32), M(33-37), L(38-42)",
    category: "roller",
    price: 150,
    column: [],
  },
  {
    order: true,
    id: 912440767673124,
    title: "Ролики детские с тормозами",
    img: "hjhhgg344.png",
    desc: "регулируемые 31-34",
    category: "roller",
    price: 120,
    column: [
      "Размер: регулируется от 31 до 34.",
      "Материал ботинка: текстиль, материал рамы: алюминий.",
      "Колёса: ПВХ, диаметр — 6,4 см, расположены в один ряд.",
      "Подшипники: класс 608Z.",
      "Тип застёжек: липучки и фиксаторы (2 застёжки).",
    ],
  },
  {
    order: true,
    id: 2912440767673124,
    title: "Ролики детские с тормозами",
    img: "600014668618b0.jpeg",
    desc: "регулируемые 31-34",
    category: "roller",
    price: 135,
    column: [
      "Детские роликовые коньки для активного и безопасного отдыха.",
      "Мягкие, дышащие и прочные ботинки обеспечивают комфорт при катании.",
      "Регулируемый размер с помощью кнопки — легко подстраивается под рост ребёнка.",
      "Прочная усиленная алюминиевая рама снижает центр тяжести для стабильности и безопасности.",
      "Система тройной фиксации: крепёжные ленты, прочные шнурки и регулируемые пряжки.",
      "8 светящихся износостойких полиуретановых колёс начинают светиться при движении.",
      "Задний тормоз для безопасной остановки ребёнка.",
      "Цвет: синий. Размер: S. Максимальная нагрузка: 75 кг.",
      "Материалы: алюминий, ПП/ПЭ. Вес упаковки: 2 кг. Размер упаковки: 41×11×34 см.",
    ],
  },
  {
    order: true,
    id: 2440764376743,
    title: "Ролики OXELO LEARN 100",
    img: "kids-inline-skates-learn-100-beige-eu-28-34-oxelo.png",
    desc: "30-32, 32-34, 32-34",
    category: "roller",
    price: 230,
    column: [
      "Идеальные роликовые коньки для начинающих детей от 3 лет!",
      "Новый дизайн с 3 колёсами делает модель легче.",
      "Регулируются на 3 размера.",
      "Благодаря липучкам их легко надевать.",
      "Для улучшения первого опыта катания и обеспечения оптимальной скорости: подшипники ABEC 1.",
      "",
    ],
  },
  {
    order: true,
    id: 2440764376743346,
    title: "Профессиональные роликовые коньки",
    img: "7988f4b5-6b43-4661-856c-58fc8281338b.webp",
    desc: "35-38 размер",
    category: "roller",
    price: 230,
    column: [
      "Удобная нескользящая и дышащая конструкция для комфортного катания.",
      "Верх: пластик, подошва: ПВХ, стелька и внутренний материал: ткань.",
      "Тип застёжки: пряжка — обеспечивает надёжную фиксацию.",
      "Подходят для использования на улице и в помещении, для повседневного и спортивного катания.",
    ],
  },
  {
    order: true,
    id: 2440764376743341,
    title: "Детские регулируемые ролики",
    img: "b1f2b627383337af48f04d809f5c9453.webp",
    desc: "28-31, 32-35, 36-39",
    category: "roller",
    price: 270,
    column: [
      "Регулируемые, модные и удобные – идеально подойдут как мальчикам, так и девочкам!",
      "Верх: хлопок, нейлон",
      "Подкладка: хлопок, нейлон",
      "Внутри: хлопок, ткань, дышащая сетка",
      "Подошва: ПВХ",
      "Прочная система фиксации: липучка + пряжка",
    ],
  },
  {
    order: true,
    id: 24407643767433412,
    title: "Сумка для детских роликов",
    img: "picture2442.png",
    desc: " OXELO 100 S",
    category: "roller",
    price: 49,
    column: [
      "Сумка для переноски и хранения детских роликовых и ледовых коньков с экипировкой.",
      "Лёгкая и удобная — подходит для транспортировки коньков, шлема и защитных аксессуаров.",
      "Усиленное дно — можно ставить на асфальт без риска повреждений.",
      "Оснащена регулируемым плечевым ремнём для комфортной переноски.",
      "Компактная и практичная для повседневного использования.",
    ],
  },
  {
    order: true,
    id: 96743341235,
    title: "Сумка для детских роликов",
    img: "picture3434.jpg",
    desc: " OXELO 500 L",
    category: "roller",
    price: 70,
    column: [
      "Сумка для хранения и переноски роликовых и ледовых коньков с экипировкой.",
      "Лёгкая и удобная — подходит для транспортировки вместе с защитными аксессуарами.",
      "Вместимость: подходит для коньков до 47 размера.",
      "Идеальна для повседневного использования и поездок на тренировки.",
    ],
  },
  {
    order: true,
    id: 924407643767123143,
    title: "Сумка для роликов",
    img: "s-l4070.jpg",
    desc: "для хранения и переноски",
    category: "roller",
    price: 55,
    column: [],
  },
  {
    order: true,
    id: 9244076437671231436,
    title: "Высокоскоростной подшипник",
    img: "fa4c6149-d0c.png",
    desc: "8x22x7mm",
    category: "roller",
    price: 2,
    column: [" из углеродистой стали 608ZZ ", " с двойным экранированием"],
  },
  {
    order: true,
    id: 92944076437671231436,
    title: "Подшипники",
    img: "49190a52206847959cace56787259b5f.webp",
    desc: "8шт в кейсе",
    category: "roller",
    price: 52,
    column: ["Подшипники abec9"],
  },
  {
    order: true,
    id: 2440764374,
    title: "Защита, набор из 6 предметов",
    img: "9d89ae16-8e53-4cae-b62a-79392297469b-Photoroom.png",
    desc: "(наколенники, налокотники, защита кисти)",
    category: "protection",
    price: 35,
    column: [
      "Надёжный набор для защиты юных спортсменов при катании на велосипеде, скейтборде, беговеле и роликах. Подходит как для мальчиков, так и для девочек.",
      "2 наколенника, 2 налокотника, 2 защитных нарукавника",
      "Изготовлены из высококачественного PE-пластика, устойчивого к износу и ударам.",
      "Отлично поглощают удары и сохраняют форму — надёжная защита при падениях.",
      "Лёгкие материалы не стесняют движений и обеспечивают комфорт при длительном ношении.",
      "Позволяют коже «дышать» и предотвращают перегрев.",
      "Подходят для детей разного возраста — легко регулируются под нужный размер.",
    ],
  },
  {
    order: true,
    id: 244076437403,
    title: "Защита",
    img: "16.05.369.png",
    desc: "колени, локти, запястье S, M, L",
    category: "protection",
    price: 35,
    column: [],
  },
  {
    order: true,
    id: 24407643740314,
    title: "Защита для роликов детская OXELO",
    img: "1_org_zoom2442.png",
    desc: "XS,S",
    category: "protection",
    price: 70,
    column: [
      "Детский защитный комплект для первых занятий на роликах и скейтборде.",
      "Включает защиту для коленей, локтей и запястий.",
      "Пластиковый корпус с усиленной пеной для надёжной амортизации ударов.",
      "Простое надевание и снятие — легко фиксируется на теле ребёнка.",
      "Регулируемые липучки позволяют подстроить размер по росту и комплекции ребёнка.",
      "Обеспечивает дополнительную безопасность для начинающих.",
    ],
  },
  {
    order: true,
    id: 2440764374031454,
    title: "Защита для роликов детская OXELO",
    img: "images2424.jpeg",
    desc: "L, XL",
    category: "protection",
    price: 120,
    column: [
      "3-в-1: защита для коленей, локтей и запястий — продаётся парой.",
      "Подходит для катания на роликах, скейтборде и самокате.",
      "Прочный ABS-корпус с пенными вставками — надёжная защита от ударов.",
      "Соответствует стандарту безопасности CE EN 14120.",
      "Мягкая ткань и дышащая сетка обеспечивают комфорт при длительном ношении.",
      "Эластичные ремни на липучках — легко регулируется по размеру.",
    ],
  },
  {
    order: true,
    id: 24407643740314543,
    title: "Набор защиты",
    img: "21efc42f-235a-46cc-888f-9992a870a59b.webp",
    desc: "взрослый",
    category: "protection",
    price: 99,
    column: [
      "Защитный комплект 3 в 1 для взрослых: наколенники, налокотники и защита запястий.",
      "Подходит для катания на роликах, скейтборде, самокате и BMX.",
      "Надёжная защита суставов от ударов и травм при активных занятиях.",
      "Прочные материалы с амортизирующими вставками обеспечивают комфорт и безопасность.",
      "Регулируемые ремни для плотной фиксации и удобной посадки.",
      "Подходит как для мужчин, так и для женщин.",
    ],
  },
  // // {
  // order:true,//
  // id: 244076437403145434,
  //   title: "Набор защиты",
  //   img: "21efc42f-235a-46cc-888f-9992a870a59b.webp",
  //   desc: "взрослый",
  //   category: "protection",
  //   price: 99,
  //   column: [
  //     "Защитный комплект 3 в 1 для взрослых: наколенники, налокотники и защита запястий.",
  //     "Подходит для катания на роликах, скейтборде, самокате и BMX.",
  //     "Надёжная защита суставов от ударов и травм при активных занятиях.",
  //     "Прочные материалы с амортизирующими вставками обеспечивают комфорт и безопасность.",
  //     "Регулируемые ремни для плотной фиксации и удобной посадки.",
  //     "Подходит как для мужчин, так и для женщин.",
  //   ],
  // },
  // {
  // order:true,//
  // id: 2440764376743341231,
  //   title: "Сумка для роликов",
  //   img: "picture3434.jpg",
  //   desc: " OXELO 500 L",
  //   category: "roller",
  //   price: 55,
  //   column: [

  //   ],
  // },
  {
    order: true,
    id: 244076437674334131351,
    title: "Шлем регулируемый Gudook",
    img: "3df0404c-6656-471a-a89c-7a13e24d7bc0.webp",
    desc: "для роликов и скейтборда",
    category: "helmet",
    price: 90,
    column: [
      "Многофункциональный защитный шлем GUDOOK для взрослых и подростков.",
      "Подходит для езды на велосипеде, скейтборде, самокате и роликах.",
      "Прочный корпус из ABS с внутренней пенопластовой подкладкой EPS — надёжная защита при ударах.",
      "Лёгкая конструкция с вентиляционными отверстиями — комфорт при длительном использовании.",
      "Регулируемая посадка — подходит для разного размера головы.",
      "Светоотражающие элементы — повышают безопасность в тёмное время суток.",
      "Универсальный дизайн — подходит и мужчинам, и женщинам.",
    ],
  },
  {
    order: true,
    id: 24407643767433413131,
    title: "Шлем регулируемый Gudook",
    img: "e48af3f4-16b7-4693-a4cb-7b6ab9b46a55.webp",
    desc: "для роликов и скейтборда",
    category: "helmet",
    price: 90,
    column: [
      "Многофункциональный защитный шлем GUDOOK для взрослых и подростков.",
      "Подходит для езды на велосипеде, скейтборде, самокате и роликах.",
      "Прочный корпус из ABS с внутренней пенопластовой подкладкой EPS — надёжная защита при ударах.",
      "Лёгкая конструкция с вентиляционными отверстиями — комфорт при длительном использовании.",
      "Регулируемая посадка — подходит для разного размера головы.",
      "Светоотражающие элементы — повышают безопасность в тёмное время суток.",
      "Универсальный дизайн — подходит и мужчинам, и женщинам.",
    ],
  },
  {
    order: true,
    id: 2440764376743341313120,
    title: "Шлем регулируемый Gudook",
    img: "d48b7823-4677-447c-a533-50e6338f0741.webp",
    desc: "для роликов и скейтборда",
    category: "helmet",
    price: 90,
    column: [
      "Многофункциональный защитный шлем GUDOOK для взрослых и подростков.",
      "Подходит для езды на велосипеде, скейтборде, самокате и роликах.",
      "Прочный корпус из ABS с внутренней пенопластовой подкладкой EPS — надёжная защита при ударах.",
      "Лёгкая конструкция с вентиляционными отверстиями — комфорт при длительном использовании.",
      "Регулируемая посадка — подходит для разного размера головы.",
      "Светоотражающие элементы — повышают безопасность в тёмное время суток.",
      "Универсальный дизайн — подходит и мужчинам, и женщинам.",
    ],
  },
  {
    order: true,
    id: 987674334131312,
    title: "Шлем Rockrider Expl 50",
    img: "mountain-bike-helmet-black-expl-50-ro.png",
    desc: "М, L",
    category: "helmet",
    price: 130,
    column: [
      "Комфорт: съёмные мягкие вставки из поролона для удобной посадки.",
      "Вентиляция: 15 вентиляционных отверстий обеспечивают хорошую циркуляцию воздуха.",
      "Вес: размер M — 320 г, размер L — 360 г.",
      "Стабильность: регулируется двумя боковыми пряжками и застёжкой под подбородком.",
      "Регулировка: задний регулятор размера с поворотной ручкой (затягивающее колесо).",
      "Защита при ударах: соответствует стандарту безопасности EN 1078 (для велосипеда, роликов, скейтборда и самоката).",
      "Размеры: M — 54-58 см, L — 58-62 см (окружность головы).",
      "Конструкция: внешний слой из поликарбоната, фиксированный козырёк, съёмная внутренняя подкладка.",
      "Габариты шлема (размер M): длина — 31 см, ширина — 22 см, высота — 15 см.",
    ],
  },
  {
    order: true,
    id: 29876743341313123,
    title: "Шлем Gudook KY-055",
    img: "69bc9515-987c-440d-9ea5-30ef787f79f7.jpg",
    desc: "М, L",
    category: "helmet",
    price: 79,
    column: [
      "Велошлем Gudook для взрослых с цельной конструкцией корпуса.",
      "Изготовлен из утолщённого высокоплотного EPS и PC — высокая ударопрочность и амортизация.",
      "Соответствует стандартам безопасности США: CPSC и ASTM.",
      "Лёгкий и прочный, система вентиляции с 22 отверстиями для хорошей циркуляции воздуха.",
      "Толстая внутренняя подкладка равномерно распределяет давление, легко снимается для чистки.",
      "Съёмный козырёк защищает от солнца и ослепления, улучшает обзор и регулирует поток воздуха.",
      "Подходит для города, шоссейных и горных велосипедов, скейтбординга, роликов и др.",
      "Полностью регулируется: размер M — 53–57 см, размер L — 57–61 см.",
      "Регулировка осуществляется колесиком, регулируемым подбородочным ремнём и мягкой накладкой на подбородок.",
    ],
  },
  {
    order: true,
    id: 2440764376743341310,
    title: "Шлем OXELO B100",
    img: "kids-inline-skates-skateboard-scooter-helmet-b100-pastel-blue-oxelo.png",
    desc: " 47-52, 52-54, светло-голубой, персиковый",
    category: "helmet",
    price: 99,
    column: [
      "Шлем для катания на роликах, скейтборде и самокате",
      "Обтекаемая форма и регулировочное колесико не дают шлему смещаться во время катания.",
      "Удобная система подгонки: колесико регулировки, пряжка и разделители на ремешках.",
      "Вес всего 340 г (размер S) — удобно даже для самых маленьких.",
      "11 крупных вентиляционных отверстий обеспечивают хорошую циркуляцию воздуха.",
    ],
  },
  {
    order: true,
    id: 324407643765743341312,
    title: "Шлем OXELO MF500",
    img: "picturekids.png",
    desc: "52-55, 55-59, 59-62 серый, черный, белый, светло-розовый",
    category: "helmet",
    price: 140,
    column: [
      "Этот шлем обеспечивает высокую устойчивость благодаря плотно облегающей конструкции и регулировочному механизму с 3D-колесиком.",
      "Механизм 3D-настройки позволяет отрегулировать высоту и глубину посадки.",
      "Есть специальное отверстие для прически в виде хвоста.",
      "12 вентиляционных отверстий, соединённых каналами, обеспечивают отличную циркуляцию воздуха.",
      "Размер S — 340 г",
      "Размер M — 400 г",
      "Размер L — 455 г",
    ],
  },
  {
    order: true,
    id: 244076543767433413122,
    title: "Шлем взрослый Kayak",
    img: "80aa7952-5e42-4da5-932c.png",
    desc: "(зеленый, желтый) ",
    category: "helmet",
    price: 110,
    column: [
      "Прочный и универсальный шлем, разработанный для максимальной безопасности при занятиях каякингом, рафтингом, скейтбордингом, водным парусным спортом, серфингом, дрифтом и прогулках по воде.",
      "Ударопрочная конструкция обеспечивает защиту даже в экстремальных условиях.",
      "Подходит как для водных, так и для сухопутных активностей.",
      "Эргономичная форма, регулируемые ремешки и хорошая посадка обеспечивают комфорт даже при длительном использовании.",
      "Внутренние материалы способствуют отведению влаги и быстрому высыханию после контакта с водой.",
      "Подходит как для мужчин, так и для женщин.",
    ],
  },
  {
    order: true,
    id: 94334131224,
    title: "Шлем BTWIN",
    img: "1_org_zoom42.png",
    desc: "3-10 лет",
    category: "helmet",
    price: 85,
    column: [
      "Детский шлем для велосипедных прогулок в возрасте 3–10 лет.",
      "Обеспечивает надёжную защиту головы при падениях.",
      "Корпус из материала EPS соответствует стандарту EN 1078.",
      "Регулируется по размеру с помощью заднего фиксирующего механизма и боковых ремней.",
      "6 вентиляционных отверстий для хорошей циркуляции воздуха.",
      "Лёгкий: вес — 200 г (XS), 220 г (S).",
      "Простой, комфортный и доступный по цене шлем для первых велопоездок.",
    ],
  },
  {
    order: true,
    id: 943341312244,
    title: "Шлем BTWIN",
    img: "picture42.png",
    desc: "взрослый",
    category: "helmet",
    price: 115,
    column: [
      "Шлем для безопасной езды на велосипеде.",
      "Регулируемая посадка благодаря системе затяжки и регулируемым ремням.",
      "Съёмные и моющиеся мягкие вставки обеспечивают комфорт.",
      "6 вентиляционных отверстий для циркуляции свежего воздуха.",
      "Есть возможность установить заднюю подсветку для повышения видимости.",
      "Соответствует стандарту безопасности EN 1078 (поглощение удара, обзор, система регулировки).",
      "Форма в виде кепки обеспечивает защиту от дождя и солнца.",
    ],
  },

  {
    order: true,
    id: 24424394449549,
    title: "Набор теннисных ракеток",
    img: "yetiskin-tenis-seti-2-raket-2-top.png",
    desc: "270 gr DECATHLON 2шт+чехол",
    category: "tennis",
    price: 250,
    column: [
      "Новички смогут сразу же открыть для себя теннис с этим набором, в который входят 2 алюминиевые ракетки для взрослых, 2 теннисных мяча и кейс.",
      "270г. Ракетка, которой легко управлять благодаря ее легкой конструкции.",
      "Алюминиевая рама обеспечивает устойчивость к ударам.",
    ],
  },
  {
    order: true,
    id: 244243944495499,
    title: "Набор теннисных ракеток",
    img: "61yQ51BsmYL.png",
    desc: "270 gr ARTENGO 2шт+чехол",
    category: "tennis",
    price: 250,
    column: [
      "Набор для начинающих игроков в теннис.",
      "В комплект входят: 2 алюминиевые ракетки для взрослых, 2 теннисных мяча и сумка.",
      "Лёгкие ракетки (270 г) — удобно держать и управлять.",
      "Большая игровая поверхность (690 см²) — проще попадать по мячу.",
      "Сумка с плечевым ремнём — удобно носить и хранить.",
    ],
  },
  {
    order: true,
    id: 244243944495499541,
    title: "Ракетка для тенниса",
    img: "picture1234.png",
    desc: "270 gr KUIKMA ",
    category: "tennis",
    price: 220,
    column: [
      "Теннисная ракетка для начинающих игроков, ищущих универсальность и простоту игры.",
      "Площадь головы 670 см² и баланс 34,5 см обеспечивают отличную управляемость.",
      "Вес 270 г — лёгкая и удобная в обращении.",
      "Обеспечивает хорошее сочетание мощности и контроля при ударах.",
      "Большая площадь головы прощает ошибки при попадании не по центру.",
      "Идеально подходит для изучения базовых движений и техники.",
    ],
  },
  {
    order: true,
    id: 24424394449549954165,
    title: "Ракетка для тенниса SALYWEE",
    img: "13cd58cd-4444-448.png",
    desc: "из карбонового композита",
    category: "tennis",
    price: 170,
    column: [
      "305 грамм",
      "Теннисная ракетка SALYWEE из углеродного композита — прочная и лёгкая.",
      "Подходит для начинающих и продвинутых игроков, как мужчин, так и женщин.",
      "Изготовлена из углеродного волокна — обеспечивает надёжность и долговечность.",
      "Идеальный баланс контроля и мощности для комфортной игры.",
      "Поставляется в комплекте с удобной сумкой для хранения и переноски.",
    ],
  },
  {
    order: true,
    id: 2442439444954995416512,
    title: "Детская теннисная ракетка",
    img: "cocuk-tenis-raketi.png",
    desc: "DECATHLON ",
    category: "tennis",
    price: 140,
    column: [
      "Теннисная ракетка для детей ростом 116–125 см, начинающих играть в теннис.",
      "Изготовлена из алюминия — лёгкая и прочная.",
      "Баланс в области головы — облегчает мощные удары для начинающих.",
      "Небольшой вес позволяет ребёнку легко контролировать ракетку и делать первые удары.",
      "Эргономичная ручка — удобно лежит в детской руке, облегчает обучение.",
    ],
  },
  {
    order: true,
    id: 24424394449549954165121,
    title: "Детская теннисная ракетка",
    img: "picture1266.png",
    desc: "ARTENGO Easy TR130",
    category: "tennis",
    price: 160,
    column: [
      "Детская теннисная ракетка TR130 — идеальна для первых ударов.",
      "Разработана совместно с тренерами и детьми, включает 6 обучающих концепций.",
      "Облегчает захват, позиционирование и движение руки.",
      "Лёгкая (216 г) — удобно держать и контролировать во время игры.",
      "Площадь головы 625 см² — прощает ошибки при неточном попадании по мячу.",
      "Материал: алюминий, двухсоставная конструкция — надёжная и долговечная.",
    ],
  },
  {
    order: true,
    id: 24424394449676654,
    title: "Набор из 3 мячей",
    img: "picture0908.jpg",
    desc: "ARTENGO",
    category: "tennis",
    price: 35,
    column: [
      "Мяч TB100 предназначен для детей 4–7 лет, начинающих осваивать теннис.",
      "Одобрен Международной и Турецкой теннисными федерациями (ITF, TTF, уровень 3).",
      "Идеален для первых ударов — сниженная скорость и мягкий отскок.",
      "Сниженный отскок на 25% по сравнению со стандартными мячами — легче контролировать.",
      "Прочные материалы обеспечивают хорошую износостойкость.",
    ],
  },
  {
    order: true,
    id: 244243944496766541,
    title: "Набор из 3 мячей",
    img: "116153720.webp",
    desc: "ITF Marka",
    category: "tennis",
    price: 47,
    column: [],
  },
  {
    order: true,
    id: 244243944496766548,
    title: "Набор из 3 мячей",
    img: "picture19866.png",
    desc: "ARTENGO TB160 3 шт",
    category: "tennis",
    price: 35,
    column: [
      "Теннисный мяч для первых подач и клубных тренировок.",
      "Без давления — дольше сохраняет форму и свойства.",
      "Прочные материалы обеспечивают высокую износостойкость.",
      "Качественная резина даёт стабильный и стандартный отскок.",
      "Идеально подходит для начинающих игроков и регулярных тренировок.",
    ],
  },
  {
    order: true,
    id: 24424394449676654891,
    title: "Набор из 4 мячей",
    img: "tenis-topu-4-adet-cok-islevli-sari-comfort-.png",
    desc: "ARTENGO COMFORT",
    category: "tennis",
    price: 65,
    column: [
      "Набор из 4 теннисных мячей ARTENGO COMFORT — для игры на твёрдом и грунтовом покрытии.",
      "Отличный баланс между динамикой, контролем и долговечностью.",
      "Высокий и стабильный отскок благодаря устойчивости к потере давления.",
      "Обеспечивает точный контроль направления при ударах.",
      "Прочный войлочный материал — устойчивая игра и долговечность мяча.",
    ],
  },
  {
    order: true,
    id: 244243944496766548912,
    title: "Мяч 1шт",
    img: "8ca3c670-3d24-46e1.png",
    desc: "для начинающих 6,4 см",
    category: "tennis",
    price: 5,
    column: [],
  },
  {
    order: true,
    id: 2442439444967665489123,
    title: "Сумка для хранения ракетки",
    img: "e8c98ae4-eacf-49c5-8b08-ad35c2a76e91.webp",
    desc: "из нейлона",
    category: "tennis",
    price: 35,
    column: [
      "Прочная сумка для хранения и переноски теннисных ракеток.",
      "Изготовлена из износостойкого нейлона.",
      "Подходит для одной ракетки.",
      "Лёгкая и компактная — удобно брать с собой.",
      "Доступна в разных цветах (разноцветная).",
      "Количество: 1 штука в комплекте.",
    ],
  },
  {
    order: true,
    id: 244243944496766548912390,
    title: "Теннисная сумка на плечо",
    img: "71H8zP9VCFL._AC_UF8.png",
    desc: "49 х 33 х 12 см ",
    category: "tennis",
    price: 90,
    column: [
      "Теннисная сумка на плечо унисекс от бренда Thousand Fish.",
      "Прочное нейлоновое покрытие, устойчивое к износу.",
      "Вместительное основное отделение — подходит для 1 теннисной или пиклбольной ракетки.",
      "Дополнительное отделение с органайзерами — для одежды, телефона, ключей и мелочей.",
      "Глубокий передний карман для мячей, сетчатый боковой — для бутылки или зонта.",
      "Мягкий регулируемый плечевой ремень (от 58 до 102 см), можно носить на левом или правом плече.",
      "Скрытый крючок для подвешивания на сетку и скрываемая петля.",
      "Антивандальная застёжка-молния для защиты ценных вещей.",
      "Сетчатая мягкая подкладка на спине — комфорт при носке тяжёлых предметов.",
      "Скрытый карман на спинке — для надёжного хранения личных вещей.",
    ],
  },
  {
    order: true,
    id: 24424394495434488,
    title: "Обмотка для ракетки",
    img: "6849178727.jpg",
    desc: "1 шт",
    category: "tennis",
    price: 8,
    column: [
      "Материал: искусственная кожа — прочная, приятная на ощупь и долговечная.",
      "Впитывают пот и обеспечивают комфортное сцепление во время игры.",
      "Противоскользящая поверхность — для надёжного удержания ракетки.",
      "Идеальны для занятий теннисом, бадминтоном, сквошем и другими ракеточными видами спорта.",
      "Доступна в нескольких цветах — для индивидуального стиля.",
    ],
  },
  {
    order: true,
    id: 24424394495434488509,
    title: "Обмотка для ракетки",
    img: "1876_org.png",
    desc: "3 шт. Цветная ARTENGO Comfort",
    category: "tennis",
    price: 35,
    column: [
      "Овергрип обеспечивает комфорт и надёжное сцепление во время игры в теннис.",
      "Легко наматывается на ручку ракетки — улучшает захват.",
      "Толщина 0,6 мм — эффективно впитывает пот и обеспечивает комфорт.",
      "Материал: полиуретан и каучук — мягкий и приятный на ощупь.",
      "Прочный и износостойкий — долго сохраняет свои свойства.",
    ],
  },
  {
    order: true,
    id: 2442439449543448850910,
    title: "Ракетка для падела",
    img: "picture23445.png",
    desc: "Kuikma PR 190",
    category: "padel",
    price: 180,
    column: [
      "Ракетка для паделя для начинающих игроков, ищущих лёгкость и комфорт.",
      "Круглая форма головы для лучшего контроля мяча.",
      "Вес: 320 ± 7 г — лёгкая и манёвренная.",
      "Сбалансированное смещение центра тяжести для лёгкого управления.",
      "Материалы: стекловолокно и EVA-пена — комфортный отскок и контроль мяча.",
      "Идеально подходит для освоения техники и первых тренировок.",
    ],
  },
  {
    order: true,
    id: 244243944954344885091029,
    title: "Мячи для падела",
    img: "picture544343.png",
    desc: "3 шт PB Control",
    category: "padel",
    price: 49,
    column: [
      "Падельный мяч для опытных игроков, подходит для игры в жаркую погоду и на высокогорье.",
      "Одобрен Федерацией паделя (FIP).",
      "Баланс контроля, динамики и износостойкости.",
      "Высокоэластичное резиновое ядро обеспечивает точный контроль мяча.",
      "Благодаря давлению мяч набирает скорость с сохранением управляемости.",
      "Синтетический войлок (73%) устойчив к истиранию и длительному использованию.",
    ],
  },
  {
    order: true,
    id: 924424394434,
    title: "Мячи для падела",
    img: "padel-topu-3-adet-pb-spee.png",
    desc: "3 шт PB Speed",
    category: "padel",
    price: 49,
    column: [
      "Падельный мяч для продвинутых игроков, идеально подходит для игры при медленных условиях (тёплая погода, уровень моря, влажность).",
      "Одобрен Федерацией паделя (FIP).",
      "Высокое давление и плотное резиновое ядро обеспечивают быстрый разгон мяча.",
      "46% натурального войлока — для стабильного контроля мяча.",
      "54% синтетического войлока — для повышенной износостойкости.",
      "Отличный баланс скорости, контроля и долговечности.",
    ],
  },
  {
    order: true,
    id: 24424394443356,
    title: "Ракетка для мини-тенниса",
    img: "small-indoor-table-tennis-set-ppr-100-with-2-bats-and-3-balls.avif",
    desc: "PONGORI PPR 100",
    category: "mini",
    price: 55,
    column: [
      "Эти компактные ракетки разработаны для лучшего контроля мяча при игре на маленьком столе.",
      "Обеспечьте отличный контроль мяча и максимальную лёгкость в управлении с ракетками PPR 100",
      "В комплект входят 3 мяча",
      "Чехол: 100% дерево",
      "Ракетка: 50% этиленвинилацетат, 50% латекс",
      "Мяч: 100% акрилонитрилбутадиенстирол",
      "Мягкая накладка и основа ракетки обеспечивают уверенные удары вблизи.",
      "Компактный размер и лёгкий вес облегчают управление при игре на маленьком столе.",
    ],
  },
  {
    order: true,
    id: 244243944456,
    title: "Набор из 2 ракеток",
    img: "table-tennis-set-of-2-durable-bats-3-balls-.png",
    desc: "PONGORI PPR 100",
    category: "mini",
    price: 80,
    column: [
      "Освойте настольный теннис легко с этим набором ракеток! PPR 100 устойчива к ударам и погодным условиям, помогая вам научиться контролировать мяч и наслаждаться более долгими розыгрышами.",
      "Этот набор из 2 ракеток и 3 мячей идеально подойдёт для начинающих. Прочные ракетки прощают ошибки и позволяют быстрее прогрессировать!",
      "Материал и форма разработаны для устойчивости к ударам и плохой погоде.",
    ],
  },
  {
    order: true,
    id: 2442439444569,
    title: "1 ракетка",
    img: "p272464998.png",
    desc: "PONGORI PPR 100",
    category: "mini",
    price: 40,
    column: [
      "Освойте настольный теннис легко с этим набором ракеток! PPR 100 устойчива к ударам и погодным условиям, помогая вам научиться контролировать мяч и наслаждаться более долгими розыгрышами.",
      "Материал и форма разработаны для устойчивости к ударам и плохой погоде.",
      "1 шт",
    ],
  },
  {
    order: true,
    id: 24424394445692,
    title: "Мяч для настольного тенниса STIGA",
    img: "76742674267а.jpg",
    desc: "3шт.",
    category: "mini",
    price: 14,
    column: [],
  },
  {
    order: true,
    id: 244243944456921,
    title: "Мяч для настольного тенниса STIGA",
    img: "1_org44242.png",
    desc: "6шт.",
    category: "mini",
    price: 18,
    column: [],
  },
  {
    order: true,
    id: 244243944456923,
    title: "Мяч для настольного тенниса",
    img: "table-tennis-ball_.avif",
    desc: "1шт.",
    category: "mini",
    price: 2,
    column: [],
  },
  {
    order: true,
    id: 7655549340198,
    title: "Набор из 2 ракеток для бадминтона",
    img: "6337498439.jpg",
    desc: "в черном чехле",
    category: "badminton",
    price: 35,
    column: [],
  },
  {
    order: true,
    id: 765554934019845,
    title: "Набор из 2 ракеток для бадминтона",
    img: "cunhus.png",
    desc: "в оранжевом кейсе",
    category: "badminton",
    price: 45,
    column: [],
  },
  {
    order: true,
    id: 76555493401984509,
    title: "Набор из 2 ракеток для бадминтона",
    img: "17.33.20.jpg",
    desc: "в оранжевом и синем кейсе",
    category: "badminton",
    price: 50,
    column: [],
  },
  {
    order: true,
    id: 24424394449549340,
    title: "Набор из 12 воланчиков",
    img: "S2b8ec593e3a049d7afd20d8bda8d6b7eX.webp",
    desc: "универсальные, лёгкие и прочные ",
    category: "badminton",
    price: 25,
    column: [],
  },
  {
    order: true,
    id: 244243944495493403,
    title: "1 воланчик",
    img: "S2b8ec593e3a049d7afd20d8bda8d6b7eX.webp",
    desc: "универсальный, лёгкий и прочный",
    category: "badminton",
    price: 4,
    column: [],
  },
  {
    order: true,
    id: 24424394449549340332,
    title: "12 воланчиков",
    img: "3-1033331.png",
    desc: "универсальные, лёгкие и прочные ",
    category: "badminton",
    price: 12,
    column: [],
  },
  {
    order: true,
    id: 2442439444954934,
    title: "Набор из 3 воланчиков",
    img: "badminton-shuttlecocks-pack-of-3-100-series-perfly.png",
    desc: "PERFLY PSC 100",
    category: "badminton",
    price: 23,
    column: [
      "Пластиковый ободок обеспечивает высокую износостойкость волана.",
      "Стабильная траектория полёта благодаря форме пластикового ободка.",
      "Мягкий наконечник из пены делает удары более комфортными — особенно удобно для начинающих.",
    ],
  },
  {
    order: true,
    id: 244244394443354361291,
    title: "Бита бейсбол",
    img: "ne-bb-70-1.jpg",
    desc: "деревянная",
    category: "baseball",
    price: 45,
    column: [],
  },
  {
    order: true,
    id: 2442443944433543612910,
    title: "Бита бейсбол",
    img: "294596261.webp",
    desc: "алюминий",
    category: "baseball",
    price: 55,
    column: [],
  },
  {
    order: true,
    id: 98443944433543612910,
    title: "Мяч бейсбольный",
    img: "2df97b49-7dac-455e-9d50-9467ea7cd0fe.jpeg",
    desc: "подходит для новичков и любителей",
    category: "baseball",
    price: 15,
    column: [],
  },
  {
    order: true,
    id: 24424439444335436129,
    title: "Фризби",
    img: "1018264996.jpg",
    desc: "классический",
    category: "frisbee",
    price: 13,
    column: [],
  },
  {
    order: true,
    id: 24424439444335436,
    title: "Фризби",
    img: "8853942.avif",
    desc: "Arrow Orange",
    category: "frisbee",
    price: 17,
    column: [
      "Опытные метатели могут бросать его на расстояние до 30 метров.",
      "Масса: 0,08 кг",
    ],
  },
  {
    order: true,
    id: 24424394443354436,
    title: "Профессиональный фризби ",
    img: "f7b2073e-089c-4bc9-b9d2-eb9a0ba3d596.webp",
    desc: "HEALTH CAMPAIGN",
    category: "frisbee",
    price: 35,
    column: [
      "Высококачественный диск из прочного полиэтилена — идеальный выбор для активного отдыха, спорта на свежем воздухе и фитнеса. Отлично подойдёт как для любителей, так и для профессионалов.",
      "Прочный и износостойкий материал",
      "Аэродинамичный дизайн для дальних и точных бросков",
      "Подходит для игры на пляже, в парке или во дворе",
      "Отличный выбор для ультиматив фрисби и других командных игр",
      "Вес: 175 гр",
    ],
  },

  {
    order: true,
    id: 24424394449549994,
    title: "Мяч волейбольный ",
    img: "p1991708.avif",
    desc: "KIPSTA VB100",
    category: "balls",
    price: 60,
    column: [
      "Приятный на ощупь мяч с хорошим сцеплением — идеален для начала занятий волейболом! Отличный выбор для изучения первых приёмов и движений.",
      "Синтетический материал обеспечивает комфортный захват.",
      "Мяч прошёл лабораторные испытания и выдержал 5000 ударов.",
    ],
  },
  {
    order: true,
    id: 244243944449549994,
    title: "Мяч волейбольный",
    img: "765.webp",
    desc: "BV100 детский",
    category: "balls",
    price: 32,
    column: [
      "Благодаря специальной технологии производства, этот мяч обладает идеальным балансом и легкостью, что делает его отличным выбором как для тренировок, так и для соревнований.",
    ],
  },
  {
    order: true,
    id: 2442439444449549994,
    title: "Мяч волейбольный",
    img: "beach-volleyball-size-5-bv100-classic-turquoise-kipsta.png",
    desc: "BV100 взрослый",
    category: "balls",
    price: 65,
    column: [
      "Очень мягкий и комфортный на ощупь — обеспечивает уверенный контакт с мячом.",
      "Проверен в лабораторных условиях — выдерживает 5000 ударов на скорости 50 км/ч.",
    ],
  },
  {
    order: true,
    id: 2440909549994,
    title: "Мяч футбольный",
    img: "size-4-football-sunny-300-green-kipsta.png",
    desc: "KIPSTA Sunny 300 4 оранжевый и бирюзовый ",
    category: "balls",
    price: 32,
    column: [
      "Мяч изготовлен из толстого ПВХ.",
      "Мяч без камеры — выполнен полностью из ПВХ.",
      "Мягкий материал для комфортной игры.",
      "Подходит для игры на траве и песке.",
      "Облегчённый мяч — меньше нагрузка при ударе.",
      "Отскок зависит от давления. Настройте под свою игру.",
    ],
  },

  {
    order: true,
    id: 9876545322,
    title: "Мяч футбольный",
    img: "myach-futbolnyj-firs.png",
    desc: "детский First Kick 5 ",
    category: "balls",
    price: 40,
    column: [
      "Оболочка из ПВХ обеспечивает надёжность и износостойкость.",
      "Оптимизированная камера обеспечивает стабильное удержание давления внутри мяча.",
      "Твёрдость соответствует классическому футбольному мячу.",
      "Отскок соответствует международным стандартам футбола.",
    ],
  },
  {
    order: true,
    id: 98765453227,
    title: "Мяч футбольный",
    img: "images8780.jpeg",
    desc: "детский First Kick 4 ",
    category: "balls",
    price: 40,
    column: [
      "Оболочка из ПВХ обеспечивает надёжность и износостойкость.",
      "Оптимизированная камера обеспечивает стабильное удержание давления внутри мяча.",
      "Твёрдость соответствует классическому футбольному мячу.",
      "Отскок соответствует международным стандартам футбола.",
    ],
  },
  {
    order: true,
    id: 98765453223,
    title: "Мяч футбольный",
    img: "8676296.jpg",
    desc: "детский First Kick 3 ",
    category: "balls",
    price: 32,
    column: [
      "Размер 3 для детей до 9 лет. Самым требовательным испытанием мяча является машинный удар.",
      "Выдерживает до 2500 ударов о наклонную бетонную поверхность на скорости 50 км/ч с расстояния 2,5 м.",
    ],
  },
  {
    order: true,
    id: 98765453223987,
    title: "Мяч футбольный",
    img: "876545678.png",
    desc: "NATIONAL GEORGIA",
    category: "balls",
    price: 70,
    column: [],
  },
  {
    order: true,
    id: 98765964,
    title: "Мяч футбольный",
    img: "17.47.25.png",
    desc: "подходит для игр на улице и на поле",
    category: "balls",
    price: 45,
    column: [],
  },
  {
    order: true,
    id: 987659641,
    title: "Мяч футбольный",
    img: "17.51.009.png",
    desc: "подходит для игр на улице и на поле",
    category: "balls",
    price: 45,
    column: [],
  },
  {
    order: true,
    id: 9876596415,
    title: "Мяч футбольный",
    img: "17.9854.50.png",
    desc: "подходит для игр на улице и на поле",
    category: "balls",
    price: 20,
    column: [],
  },
  {
    order: true,
    id: 92876596415,
    title: "Мяч футбольный",
    img: "m-yach-futbolnij-5-pvc-330g-fb24329.jpg",
    desc: "подходит для игр на улице и на поле",
    category: "balls",
    price: 30,
    column: [],
  },
  {
    order: true,
    id: 987659641580,
    title: "Мяч футбольный",
    img: "018.29.27.png",
    desc: "подходит для игр на улице и на поле",
    category: "balls",
    price: 25,
    column: [],
  },
  {
    order: true,
    id: 9876596415806,
    title: "Мяч футбольный",
    img: "018.29.27.png",
    desc: "подходит для игр на улице и на поле",
    category: "balls",
    price: 20,
    column: [],
  },
  {
    order: true,
    id: 98765964158069,
    title: "Мяч Регби 9",
    img: "american-football-with-brown-leather-texture-white-laces-white-background.jpg",
    desc: "классический",
    category: "balls",
    price: 55,
    column: [],
  },
  {
    order: true,
    id: 987654532232,
    title: "Мяч для мини-футбола Sunny 300 1",
    img: "open-uri20240628-2483388-scidbd.jpeg",
    desc: "розовый и бирюзовый",
    category: "balls",
    price: 32,
    column: [
      "Футбол, сделанный из утолщенного материала из пвх",
      "Упругая интенсивность зависит от давления шарика.подходит для игр",
      "Его можно использовать в траве, песке и воде.",
    ],
  },
  // {
  // order:true,//
  // id: 9890654532232,
  //   title: "Мяч Регби 9",
  //   img: "open-uri20240628-2483388-scidbd.jpeg",
  //   desc: "",
  //   category: "balls",
  //   price: 55,
  //   column: [

  //   ],
  // },
  {
    order: true,
    id: 924476544323,
    title: "Мяч баскетбольный",
    img: "18.40.32.png",
    desc: "для тренировок и игр",
    category: "balls",
    price: 55,
    column: [],
  },
  {
    order: true,
    id: 24440954909549990494,
    title: "Мяч баскетбольный",
    img: "764335.webp",
    desc: "TARMAK R100 7 ",
    category: "balls",
    price: 50,
    column: [
      "Баскетбольный мяч R100 размером 7 отлично подойдет для игры и тренировок как на улице, так и в помещении. ",
      "Он прошел испытание на прочность и способен выдержать не менее 2500 ударов о бетон при скорости до 50 км/ч.",
      "Покрытие камеры обеспечивает стабильное давление и хороший отскок мяча.",
    ],
  },
  {
    order: true,
    id: 244409549095499904949,
    title: "Мяч баскетбольный",
    img: "765888.webp",
    desc: "TARMAK R100 5 ",
    category: "balls",
    price: 50,
    column: [
      "Баскетбольный мяч R100 размером 7 отлично подойдет для игры и тренировок как на улице, так и в помещении. ",
      "Он прошел испытание на прочность и способен выдержать не менее 2500 ударов о бетон при скорости до 50 км/ч.",
      "Мяч сделан из 100% натурального каучука с обмоткой из 100% полиэтилентерефталата (ПЭ)",
    ],
  },
  {
    order: true,
    id: 871234567,
    title: "Мяч баскетбольный 7",
    img: "3e884d70-745a-4b09-bc88-7e4bf68e695b_800x800.webp",
    desc: "черный in|outdoor",
    category: "balls",
    price: 75,
    column: [
      "Баскетбольный мяч размера 7 (74,93 см).",
      "Подходит для игры в зале и на открытых площадках.",
      "Материал: синтетическая резина — прочный и износостойкий.",
    ],
  },
  {
    order: true,
    id: 1871234567,
    title: "Мяч волейбольный",
    img: "18.44.180.png",
    desc: "Humble",
    category: "balls",
    price: 45,
    column: [],
  },
  {
    order: true,
    id: 1871234567598,
    title: "Мяч волейбольный",
    img: "18.49.15.png",
    desc: "Mikasa Replic ",
    category: "balls",
    price: 50,
    column: [],
  },
  {
    order: true,
    id: 18712345675968,
    title: "Мяч волейбольный",
    img: "18.51.50.png",
    desc: "Defeeat ",
    category: "balls",
    price: 45,
    column: [],
  },
  {
    order: true,
    id: 1249763123689,
    title: "Насос",
    img: "988871.png",
    desc: "для мяча",
    category: "pump",
    price: 15,
    column: [],
  },
  {
    order: true,
    id: 91249763123689,
    title: "Насос",
    img: "998787661.png",
    desc: "для мячей, велосипедов",
    category: "pump",
    price: 25,
    column: [],
  },
  {
    order: true,
    id: 912497631236897,
    title: "Насос",
    img: "6562506036.jpg",
    desc: "ножной для велосипеда, мячей, фитболов",
    category: "pump",
    price: 32,
    column: [],
  },
  {
    order: true,
    id: 244095496509549990494,
    title: "Игла",
    img: "66eee86a-c7e0-453d-875e-0db8501f3c7c.webp",
    desc: "для мяча",
    category: "pump",
    price: 29,
    column: [
      "Подходит для футбольных, баскетбольных и волейбольных мячей. Удобный и компактный аксессуар для быстрого надува.",
    ],
  },
  {
    order: true,
    id: 8765233451,
    title: "Насос для мячей",
    img: "futbol-topu.png",
    desc: "DECATHLON",
    category: "pump",
    price: 32,
    column: [
      "Компактный односторонний насос для накачивания футбольных мячей.",
      "Простой и эффективный способ поддерживать правильное давление в мяче.",
      "Идеально подходит для игроков и тренеров.",
      "Портативный: лёгкий и компактный — удобно брать с собой.",
      "В комплект входит игла для накачки.",
    ],
  },
  {
    order: true,
    id: 2442439097994323,
    title: "Турник настенный",
    img: "Photo_Jun_23_11_13_41_AM__61153_1024x.webp",
    desc: "3 хвата",
    category: "fitness",
    price: 130,
    column: [
      "Настенный турник из прочной стальной трубы толщиной 4 см.",
      "Размеры турника: 95×52 см, крепления: 9,5×18 см.",
      "Максимальная нагрузка: до 150 кг.",
      "Укрепляет спину, плечи, грудь, руки, трицепсы, бицепсы и пресс.",
      "Можно выполнять подтягивания, отжимания и другие упражнения.",
      "Рукоятки покрыты износостойкой пеной — комфортный хват, не скользят от пота.",
      "Простая сборка: в комплекте инструкция и всё необходимое крепление.",
      "Компактный, заменяет множество другого спортивного оборудования.",
      "Идеален для создания домашнего спортзала.",
    ],
  },
  {
    order: true,
    id: 924424390979943236,
    title: "Турник",
    img: "ea14258d7c.webp",
    desc: "в дверной проем",
    category: "fitness",
    price: 85,
    column: [
      "Телескопический дверной турник для подтягиваний и силовых тренировок.",
      "Регулируемая длина: 60–100 см (24–40 дюймов) — подходит для разных дверных проёмов.",
      "Максимальная нагрузка: до 200 кг (440 фунтов).",
      "Прочная стальная труба обеспечивает надёжность и безопасность.",
      "Ручки с пенопластовой подкладкой — противоскользящие, впитывают пот, комфортны в использовании.",
      "Быстрая установка без сверления — не повреждает дверные косяки.",
      "Подходит для подтягиваний, отжиманий, скручиваний, приседаний и растяжек.",
      "В комплект входят: перекладина и 2 противоскользящие накладки.",
      "Материалы: сталь, пена.",
    ],
  },
  {
    order: true,
    id: 244243909799432,
    title: "Перчатки для фитнеса",
    img: "sarung-tangan-gym-fitness-latihan-beban-100-corength-8595161.jpg",
    desc: "CORENGTH S,L,XL",
    category: "fitness",
    price: 35,
    column: [
      "Эти перчатки для силовых тренировок — идеальный помощник, который поможет сохранить руки чистыми во время силовых тренировок в спортзале.",
      "Противоскользящий материал на ладони.",
      "Мягкие вставки из пены в местах соприкосновения с грифом.",
      "Система с петелькой для удобного снятия.",
      "Открытая тыльная часть и вентилируемая вязка обеспечивают отличную циркуляцию воздуха.",
    ],
  },
  {
    order: true,
    id: 24424394409799432,
    title: "Перчатки для фитнеса",
    img: "breathable-durable-fitness-gloves-purple-black-corength.png",
    desc: "CORENGTH S,L ",
    category: "fitness",
    price: 65,
    column: [
      "Открытая конструкция с перфорированной сеткой на тыльной стороне — ваши руки дышат и остаются сухими.",
      "Эти фитнес-перчатки идеально подходят для групповых занятий и повторяющихся движений. Будь то тренировка с лёгкими гантелями или интенсивный групповой класс — перчатки защитят ваши руки и улучшат хват.",
    ],
  },
  {
    order: true,
    id: 9409799432,
    title: "Пояс для тренировок",
    img: "siyah-kas-gelistirm.png",
    desc: "CORENGTH M~L, X~2XL",
    category: "fitness",
    price: 85,
    column: [
      "Пояс для силовых тренировок, тяжёлой атлетики и кросс-тренинга.",
      "Двойная система застёжки — легко затягивается и ослабляется одним движением.",
      "Обеспечивает надёжную поддержку поясницы и брюшных мышц.",
      "Улучшает стабильность корпуса при выполнении упражнений.",
      "Усиленные швы для дополнительной прочности.",
    ],
  },
  {
    order: true,
    id: 9409799432568,
    title: "Лямки для штанги",
    img: "896dfaa3-d811-4053-8c8a-da77279f1baf.webp",
    desc: "SKDK ",
    category: "fitness",
    price: 30,
    column: [
      "Пара ремней для запястий SKDK с усиленным захватом для силовых тренировок.",
      "Подходят для бодибилдинга, жима, тяги, тренажёров и силовых упражнений.",
      "Дышащий сетчатый материал — комфорт при длительных тренировках.",
      "Регулируемые ремни для надёжной фиксации запястья.",
      "Обеспечивают дополнительную защиту и стабилизацию суставов.",
      "Удобны при работе с тяжёлыми весами.",
    ],
  },
  {
    order: true,
    id: 94097994325466090,
    title: "Лямки для штанги",
    img: "cekme-kayisi-siyah.png",
    desc: "до 250 кг DOMYOS",
    category: "fitness",
    price: 35,
    column: [
      "Ремни для тяги с удобными петлями — снижают нагрузку на кисти и предплечья.",
      "Помогают выполнять упражнения на тягу эффективнее и безопаснее.",
      "Прочные материалы обеспечивают надёжный хват на штанге и грифе.",
      "Максимальная нагрузка: до 250 кг.",
      "Компактны и удобны для хранения — легко брать с собой на тренировку.",
      "Идеальны для бодибилдинга, силовых тренировок и кроссфита.",
    ],
  },
  {
    order: true,
    id: 94097994325466,
    title: "Ролик для пресса",
    img: "rolik-dlya-pressa-ab-power.jpg",
    desc: "укрепляет пресс, спину и руки",
    category: "fitness",
    price: 32,
    column: [],
  },
  {
    order: true,
    id: 194097994325466,
    title: "Гантели",
    img: "90798593_gantel-v-vinilovoj.webp",
    desc: "1кг",
    category: "fitness",
    price: 19,
    column: [],
  },
  {
    order: true,
    id: 2194097994325466,
    title: "Упоры для отжиманий",
    img: "9feec68f6e5.webp",
    desc: "для домашних тренировок",
    category: "fitness",
    price: 58,
    column: [
      "Пара эргономичных стоек для отжиманий для мужчин.",
      "Нескользящие текстурированные ручки обеспечивают надёжный захват.",
      "Подходят для домашних и заловых тренировок, силовых и функциональных упражнений.",
      "Максимальная нагрузка: до 136 кг (300 фунтов).",
      "Лёгкая сборка и разборка — удобно брать с собой и хранить.",
      "Материал: ПВХ — прочный и лёгкий.",
      "Размер одной стойки: 22×13×10 см (8,7×5,1×4,1 дюйма).",
      "Вес пары: 530 г (1,16 фунта).",
      "Не требует питания (механическое устройство).",
    ],
  },
  {
    order: true,
    id: 219409479943254664,
    title: "Упоры для отжиманий",
    img: "b274dc09-24.png",
    desc: "на платформе",
    category: "fitness",
    price: 60,
    column: [
      "Многофункциональная доска для отжиманий с 28 отверстиями для различных хватов.",
      "Предназначена для тренировки мышц кора, груди, рук и пресса.",
      "Позволяет варьировать положение рук для проработки разных групп мышц.",
      "Материал: прочный ABS-пластик.",
      "Механическое устройство — не требует питания.",
      "Компактная и удобная для использования дома и в спортзале.",
    ],
  },
  {
    order: true,
    id: 2194094799432546684,
    title: "Водонепроницаемый тейп",
    img: "2b3b028c0f3b8b6f5fb-goods.webp",
    desc: "5.0 см x 5.0 метра",
    category: "fitness",
    price: 25,
    column: [
      "Эластичная спортивная лента для поддержки мышц и суставов.",
      "Размеры: 2,5 см × 5 м и 5 см × 5 м.",
      "Подходит для гимнастики, бега, фитнеса и реабилитации.",
      "Обеспечивает профилактику и облегчает восстановление после травм.",
      "Водонепроницаемая, дышащая, не оставляет следов после снятия.",
      "Эластичность, близкая к коже — комфортное прилегание без зажимов.",
      "Материал: высококачественный хлопок с высокой кручёнкой.",
      "Имеет разметку на обратной стороне для удобства нарезки.",
      "Доступна в различных цветах: розовый, лесной зелёный, багровый, угольный, мандариновый, тёмно-синий, песочный, лавандовый, слоновая кость, горчичный, лазурный.",
      "Новый продукт высокого качества.",
    ],
  },
  {
    order: true,
    id: 10445545430048844354,
    title: "Шейкер MyProtein",
    img: "eb87bf73-7c37-44.png",
    desc: "500мл",
    category: "shaker",
    price: 25,
    column: [
      "Объём: 500 мл",
      "Материал: прочный и безопасный PC-пластик, не содержит BPA",
      "Герметичная конструкция — не протекает, удобно брать с собой",
      "Портативный формат — помещается в спортивную сумку или рюкзак",
      "Откидной верх — легко открывается одной рукой",
    ],
  },
  {
    order: true,
    id: 104455865040,
    title: "Шейкер",
    img: "86a99b656.webp",
    desc: "500мл",
    category: "shaker",
    price: 18,
    column: [
      "Объём: 500 мл",
      "Материал: высококачественный PP (полипропилен) — безопасный и долговечный",
    ],
  },
  {
    order: true,
    id: 1940445586504012,
    title: "Шейкер",
    img: "1f2e2141cfa62a_original.jpeg",
    desc: "прозрачный 600мл",
    category: "shaker",
    price: 14,
    column: [],
  },
  {
    order: true,
    id: 591044558650401,
    title: "Шейкер ProSports",
    img: "700-nw.jpg",
    desc: "ProSports 500мл",
    category: "shaker",
    price: 23,
    column: [],
  },
  {
    order: true,
    id: 591094455865040134,
    title: "Эспандер",
    img: "ayarlanabilir-el-yayi-8-40-kg.avif",
    desc: "8-40 Kg CORENGTH",
    category: "extender",
    price: 45,
    column: [
      "Эспандер для развития силы хвата, предплечий и реабилитации кистей.",
      "Регулируемое сопротивление: от 8 до 40 кг (5 уровней нагрузки).",
      "Легко настраивается под индивидуальные потребности благодаря удобному механизму регулировки.",
      "Эргономичная рукоятка с рельефным покрытием обеспечивает надёжный и комфортный захват во время тренировки.",
      "Идеально подходит для укрепления кистей, предплечий и восстановления после травм.",
    ],
  },
  {
    order: true,
    id: 2591094455865040134,
    title: "Эспандер",
    img: "espander2.webp",
    desc: "металлический",
    category: "extender",
    price: 26,
    column: [],
  },
  {
    order: true,
    id: 12591094455865040134,
    title: "Эспандер",
    img: "71FpkL8LMuL._AC_UF1000,1000_QL80_.jpg",
    desc: "с пластиковой рукоятью",
    category: "extender",
    price: 13,
    column: ["80.25 x 6.25 x 13.25 см", " 1.2 кг"],
  },
  {
    order: true,
    id: 1259109913490,
    title: "Эспандер",
    img: "ee30fd44a3n.webp",
    desc: "кольцо",
    category: "extender",
    price: 11,
    column: [
      "Силиконовый тренажёр-носилка для пальцев для развития силы кистей и пальцев.",
      "Размер: 7 см (2,76 дюйма).",
      "Подходит для использования дома, в тренажёрном зале, танцевальной студии и др.",
      "Материал: прочный и эластичный силикон.",
    ],
  },
  {
    order: true,
    id: 5910944558650401346,
    title: "Эспандер",
    img: "b9b23881-6e77-4a6a-abae-99ece1d35abf.webp",
    desc: "с двойным захватом",
    category: "extender",
    price: 13,
    column: [
      "Силиконовый тренажёр для укрепления кистей, пальцев и предплечий.",
      "Помогает развивать силу хвата и мышцы рук.",
      "Подходит для тренировок, реабилитации и снятия стресса.",
      "Изготовлен из прочного и эластичного силикона — приятный на ощупь и долговечный.",
      "Доступен в цветах: зелёный, синий, чёрный.",
      "Компактный размер — удобно использовать дома, в офисе и в дороге.",
    ],
  },
  {
    order: true,
    id: 59109445586504013468,
    title: "Эспандер",
    img: "6956_original.jpeg",
    desc: "кистевой на пальцы",
    category: "extender",
    price: 10,
    column: [
      "Силиконовый расширитель для пальцев для упражнений, реабилитации и расслабления.",
      "Развивает силу пальцев, кистей и предплечий.",
      "Идеален для восстановления после травм, снятия напряжения и тренировок мышц кисти.",
      "Портативный — удобно использовать дома, в офисе и в дороге.",
      "Материал: прочный и эластичный силикон.",
    ],
  },
  {
    order: true,
    id: 959109445586504013468,
    title: "Эспандер силовой",
    img: "6956_original.jpeg",
    desc: "со счетчиком сжатий",
    category: "extender",
    price: 49,
    column: [
      "Регулируемый ручной тренажёр для силы хвата с механическим счётчиком повторений.",
      "Диапазон сопротивления: от 5 до 100 кг — подходит для любого уровня подготовки.",
      "Точная настройка нагрузки с помощью вращающегося регулятора.",
      "Прочная конструкция из нержавеющей стали — устойчив к износу, ржавчине и поломке.",
      "Усиленная пружина высокой прочности обеспечивает долговечность.",
      "Противоскользящая и устойчивая к поту эргономичная ручка — надёжный и комфортный захват.",
      "Идеален для тренировок кистей, пальцев, предплечий, а также для реабилитации.",
      "Материал: TPR, PP, сталь.",
      "Цвета: оранжевый, красный, серый.",
      "Размер: 160×110 мм, вес: 195 г.",
    ],
  },
  {
    order: true,
    id: 910779999543137,
    title: "Скакалка со счетчиком",
    img: "6653934320.jpg",
    desc: "ROPE SC",
    category: "jumprope",
    price: 25,
    column: [
      "Скакалка со счётчиком для фитнеса, разминки и сжигания калорий.",
      "Ручки покрыты антискользящим пластиком — предотвращают скольжение и впитывают влагу.",
      "Специальная конструкция ручек предотвращает запутывание шнура и продлевает срок службы.",
      "Быстрая регулировка длины без использования инструментов.",
      "Удобна и безопасна в использовании как дома, так и в спортзале.",
    ],
  },
  {
    order: true,
    id: 1910779999543137,
    title: "Скакалка",
    img: "51vG1csX4LL._AC_UF894,1000_QL80_.jpg",
    desc: "JUMP ROPE",
    category: "jumprope",
    price: 10,
    column: [],
  },
  {
    order: true,
    id: 21910779999543137,
    title: "Скакалка",
    img: "skakalka-shvidkisna-zi-stalevim-trosom-zelena-jr19226-jr19226-700x700.jpg",
    desc: "лёгкая",
    category: "jumprope",
    price: 18,
    column: [],
  },
  {
    order: true,
    id: 10779999543137,
    title: "Скакалка DOMYOS",
    img: "basic-skipping.png",
    desc: " JR100",
    category: "jumprope",
    price: 20,
    column: [
      "Длина, в сантиметрах: 300",
      "Материал шнура: пвх",
      "Материал ручек: пвх",
    ],
  },
  {
    order: true,
    id: 1077993299543137,
    title: "Cкакалка DOMYOS",
    img: "skipping-rope.png",
    desc: "IPI500",
    category: "jumprope",
    price: 40,
    column: [
      "Эргономичный захват: Толстые (27 мм) эргономичные ручки из пеноматериала для идеального захвата.",
      "Скакалка из ПВХ",
      "Трёхметровая скакалка с системой регулировки по высоте.",
      "Ручки из пеноматериала отводят влагу для комфортного хвата.",
    ],
  },
  {
    order: true,
    id: 107799329954313799,
    title: "Скакалка DOMYOS ",
    img: "skipping-rope-500-rubber-red.png",
    desc: "JR500",
    category: "jumprope",
    price: 40,
    column: [
      "Эргономичный захват: Толстые (27 мм) эргономичные ручки из пеноматериала для идеального захвата.",
      "Скакалка из ПВХ",
      "Трёхметровая скакалка с системой регулировки по высоте.",
      "Ручки из пеноматериала отводят влагу для комфортного хвата.",
    ],
  },

  {
    order: true,
    id: 11207799043909799,
    title: "Борцовская резина 10 мм",
    img: "ori123g3.png",
    desc: "5 метров Х 5-12 кг (синяя)",
    category: "elasticbands",
    price: 49,
    column: [
      "Универсальный резиновый эспандер — борцовский жгут для проработки всех мышечных групп.",
      "Часто используется спортсменами боевых искусств для отработки бросков, проходов и ударов.",
      "Подходит для круговых тренировок, укрепления мышц и развития выносливости.",
      "Эффективен для силовых тренировок, восстановления после травм и поддержания общего тонуса.",
      "Максимальная нагрузка: 12 кг.",
      "Материал: силикон. Цвет: красный.",
      "Габариты: ширина — 1 см.",
    ],
  },
  {
    order: true,
    id: 141207799043909799,
    title: "Борцовская резина 14 мм",
    img: "11lotka.jpg.webp",
    desc: "3 метра Х 9-17 кг (красная)",
    category: "elasticbands",
    price: 52,
    column: [
      "Материал: силикон",
      "Максимальная нагрузка: 17 кг",
      "Ширина: 1.4 см",
      "Комплектация: эспандер резиновый жгут — 1 шт., инструкция — 1 шт.",
      "Страна производства: Россия",
      "Фитнес резинка (борцовский жгут) — универсальный резиновый эспандер для тренировки всех мышечных групп",
      "Используется спортсменами боевых единоборств — борьба, контактные виды спорта",
      "Подходит для отработки подхватов, бросков, ударов",
      "Укрепляет мышцы и развивает сердечно-сосудистую систему",
      "Эффективен для круговых тренировок, силовой и мышечной выносливости",
      "Подходит для восстановления после травм и реабилитации",
      "Прост в использовании и универсален в применении",
    ],
  },
  {
    order: true,
    id: 14512507799043909799,
    title: "Борцовская резина 14 мм",
    img: "3414.43.41.jpg",
    desc: "3 метра Х 9-17 кг (черная)",
    category: "elasticbands",
    price: 52,
    column: [
      "Материал: силикон",
      "Максимальная нагрузка: 17 кг",
      "Ширина: 1.4 см",
      "Комплектация: эспандер резиновый жгут — 1 шт., инструкция — 1 шт.",
      "Страна производства: Россия",
      "Фитнес резинка (борцовский жгут) — универсальный резиновый эспандер для тренировки всех мышечных групп",
      "Используется спортсменами боевых единоборств — борьба, контактные виды спорта",
      "Подходит для отработки подхватов, бросков, ударов",
      "Укрепляет мышцы и развивает сердечно-сосудистую систему",
      "Эффективен для круговых тренировок, силовой и мышечной выносливости",
      "Подходит для восстановления после травм и реабилитации",
      "Прост в использовании и универсален в применении",
    ],
  },
  {
    order: true,
    id: 1451250983909799,
    title: "Борцовская резина 14 мм",
    img: "3414.43.41.jpg",
    desc: "5 метра Х 9-17 кг (черная)",
    category: "elasticbands",
    price: 70,
    column: [
      "Материал: силикон",
      "Максимальная нагрузка: 17 кг",
      "Ширина: 1.4 см",
      "Комплектация: эспандер резиновый жгут — 1 шт., инструкция — 1 шт.",
      "Страна производства: Россия",
      "Фитнес резинка (борцовский жгут) — универсальный резиновый эспандер для тренировки всех мышечных групп",
      "Используется спортсменами боевых единоборств — борьба, контактные виды спорта",
      "Подходит для отработки подхватов, бросков, ударов",
      "Укрепляет мышцы и развивает сердечно-сосудистую систему",
      "Эффективен для круговых тренировок, силовой и мышечной выносливости",
      "Подходит для восстановления после травм и реабилитации",
      "Прост в использовании и универсален в применении",
    ],
  },
  {
    order: true,
    id: 107799043909799,
    title: "Набор из 3 фитнес-резинок",
    img: "resistance-bands-fitness-isi-3-ketahanan-5-6-7-kg-abu-marun-hitam-domyos-8528803.avif",
    desc: "5-6-7 кг DOMYOS",
    category: "elasticbands",
    price: 30,
    column: [
      "Аксессуар для различных упражнений на всё тело — как в положении стоя, так и лёжа!",
      "Лёгкий, удобный для хранения и транспортировки. Вы можете брать его с собой куда угодно!",
      "3 резиновых эспандера предлагают 3 уровня сопротивления, чтобы соответствовать вашему прогрессу!",
    ],
  },
  {
    order: true,
    id: 10779439329954313799,
    title: "Набор фитнес резинок",
    img: "0-1000x1000.jpg",
    desc: "тканевые, 3шт",
    category: "elasticbands",
    price: 46,
    column: [],
  },
  {
    order: true,
    id: 1077990439097994,
    title: "Резинка CORENGTH",
    img: "direnc-bandi-15-kg-yesil.avif",
    desc: "с нагрузкой 15 кг S",
    category: "elasticbands",
    price: 50,
    column: [
      "Длина пустой ленты весом 15 кг составляет 1,04 метра.",
      "Длина ремешка 13 мм.",
      "Он обеспечивает сопротивление 15 кг, то есть, чтобы растянуть шину на 200% от ее размера, необходимо приложить силу в 15 кг.",
    ],
  },
  {
    order: true,
    id: 107799043909799432,
    title: "Эластичная фитнес-резинка DOMYOS",
    img: "elastik-pilates-bandi-3-kg-bordo-orta-seviye.avif",
    desc: "с нагрузкой 2 и 3 кг",
    category: "elasticbands",
    price: 20,
    column: [
      "Резинка: 100,0% Синтетический каучук",
      "Хранить в чистом и сухом месте. Избегайте хранения вблизи источников тепла.",
      "Прорабатывайте все тело, выполняя разнообразные упражнения с этим аксессуаром!",
    ],
  },
  {
    order: true,
    id: 31243909799432,
    title: "Высокопрочные петли",
    img: "7d4449f6-b7d4-4050-a130.png",
    desc: "удобеные в использовании",
    category: "elasticbands",
    price: 59,
    column: [],
  },
  {
    order: true,
    id: 9312439097994321,
    title: "Резина для тренировок ",
    img: "d848075d-92ea.png",
    desc: "8-16 кг",
    category: "elasticbands",
    price: 35,
    column: ["2,08 м, 13 х 4,5 мм"],
  },
  {
    order: true,
    id: 5931243903297994328,
    title: "Резина для тренировок ",
    img: "3b4b56bb-dc70.png",
    desc: "25-40 кг",
    category: "elasticbands",
    price: 45,
    column: ["2,08 м 24 х 4,5 мм"],
  },
  {
    order: true,
    id: 6293124390979943287,
    title: "Резина для тренировок ",
    img: "9923d480-23ea-4722.png",
    desc: "30-45 кг",
    category: "elasticbands",
    price: 60,
    column: ["2,08 м 29 х 4,5 мм"],
  },
  {
    order: true,
    id: 2931243909799432814,
    title: "Резинка для йоги и фитнеса",
    img: "25f11677-0731-4b0c-9e42-059be7b66853-Photoroom.png",
    desc: "15 кг",
    category: "elasticbands",
    price: 25,
    column: [
      "Портативный набор премиум-резинок из материала TPE для полноценной тренировки.",
      "Универсальны: подходят для йоги, фитнеса, растяжки и силовых упражнений.",
      "Материал TPE — прочный, эластичный и долговечный.",
      "Доступны в различных уровнях сопротивления и цветах: фиолетовый, красный, зелёный.",
      "Компактны и удобны для использования дома, в зале или в путешествиях.",
      "Идеальны для мужчин и женщин любого уровня подготовки.",
    ],
  },
  {
    order: true,
    id: 29312439097994328143,
    title: "Резинка для йоги и фитнеса",
    img: "d345370c-79ae-4387-890f-664fa244de1b-Photoroom.png",
    desc: "40 кг",
    category: "elasticbands",
    price: 45,
    column: [
      "Портативный набор премиум-резинок из материала TPE для полноценной тренировки.",
      "Универсальны: подходят для йоги, фитнеса, растяжки и силовых упражнений.",
      "Материал TPE — прочный, эластичный и долговечный.",
      "Доступны в различных уровнях сопротивления и цветах: фиолетовый, красный, зелёный.",
      "Компактны и удобны для использования дома, в зале или в путешествиях.",
      "Идеальны для мужчин и женщин любого уровня подготовки.",
    ],
  },
  {
    order: true,
    id: 293126439097994328143,
    title: "Резинка для йоги и фитнеса",
    img: "f7207bcb-8a41-45a2.png",
    desc: "50 кг",
    category: "elasticbands",
    price: 52,
    column: [
      "Портативный набор премиум-резинок из материала TPE для полноценной тренировки.",
      "Универсальны: подходят для йоги, фитнеса, растяжки и силовых упражнений.",
      "Материал TPE — прочный, эластичный и долговечный.",
      "Доступны в различных уровнях сопротивления и цветах: фиолетовый, красный, зелёный.",
      "Компактны и удобны для использования дома, в зале или в путешествиях.",
      "Идеальны для мужчин и женщин любого уровня подготовки.",
    ],
  },
  {
    order: true,
    id: 3293124390979943281,
    title: "Блок",
    img: "2vefe5.jpg",
    desc: "для растяжки и пилатеса",
    category: "mats",
    price: 15,
    column: [""],
  },
  {
    order: true,
    id: 10340054,
    title: "Коврик TR Pilates",
    titleEng: "",
    img: "CGiBiTNufHIJPB2V.jpg",
    desc: "180*60*1 см",
    descEng: "180*60*1 сm",
    category: "mats",
    price: 57,
    order: true,
    column: [
      "Верхняя поверхность из полиэтилена предотвращает скольжение и впитывает пот.",
    ],
    columnEng: [""],
  },
  {
    order: true,
    id: 10340054541,
    title: "Коврик для Фитнеса DOMYOS",
    img: "picture3424.png",
    desc: "140*650*66,5 MM",
    category: "mats",
    price: 33,
    column: [
      "Коврик для растяжки и упражнений на полу.",
      "Размер: 140×50 см, толщина: 6,5 мм — обеспечивает комфорт и защиту от твёрдого пола.",
      "Обеспечивает хорошую амортизацию и устойчивость во время занятий.",
      "Поверхность с противоскользящим покрытием для безопасных тренировок.",
      "Компактный размер — удобно использовать дома, в зале и на занятиях йогой.",
    ],
  },
  {
    order: true,
    id: 1004054,
    title: "КОВРИК ПЕНКА",
    img: "coccuga83ve66.png",
    desc: "тонкие ( цвета в ассортименте )",
    category: "mats",
    price: 26,
    column: ["Нескользящий"],
  },
  {
    order: true,
    id: 10430324054,
    title: "Коврик-пенка средней толщины",
    img: "721324-beec093052ac9fb4048819c27909dc01.webp",
    desc: "средней толщины ( цвета в ассортименте )",
    category: "mats",
    price: 35,
    column: ["Нескользящий"],
  },
  {
    order: true,
    id: 104304054,
    title: "Коврик для йоги прилипающий",
    img: "13.143.46.jpg",
    desc: "173*61*0.8см ( цвета в ассортименте )",
    category: "mats",
    price: 38,
    column: ["Нескользящий"],
  },

  {
    order: true,
    id: 134300054,
    title: "КОВРИК ПЕНКА",
    titleEng: "MAT",
    img: "13.18.4398.png",
    desc: "6 мм ( цвета в ассортименте )",
    descEng: "173*61*0.8сm",
    category: "mats",
    price: 65,
    column: ["Нескользящий"],
    columnEng: ["Non-slip"],
  },

  {
    order: true,
    id: 98134300054,
    title: "Массажный ролик",
    img: "67429309.webp",
    desc: "мягкий",
    category: "hoop",
    price: 45,
    column: ["Материал:вспененный полиэтилен", "Диаметр:15 см", "Длина:450 см"],
  },
  {
    order: true,
    id: 298134300054,
    title: "Массажный ролик",
    img: "13.43.31.jpg",
    desc: "твердый",
    category: "hoop",
    price: 65,
    column: ["Материал:вспененный полиэтилен", "Диаметр:15 см", "Длина:450 см"],
  },
  {
    order: true,
    id: 29813430005409,
    title: "Массажный мяч",
    img: "coverb.jpg",
    desc: "DECATHLON",
    category: "hoop",
    price: 27,
    column: [
      "Этот мяч предназначен для самомассажа после занятий спортом. Он помогает глубоко проработать мышцы и триггерные точки.",
      "Отлично подходит для массажа свода стопы, спины и икроножных мышц.",
      "Позволяет выполнять самомассаж. Используется на полу (для стоп и ног) или у стены (для спины).",
      "Компактный дизайн — берите с собой куда угодно.",
    ],
  },
  {
    order: true,
    id: 298134300054091,
    title: "Массажный мяч",
    img: "48f5431518ec6cf847.png",
    desc: "удобен в использовании",
    category: "hoop",
    price: 15,
    column: [
      "Массажный мяч для йоги и релаксации мышц.",
      "Идеален для точечного массажа стоп, мышц и триггерных зон.",
      "Материал: прочный и эластичный TPE (термопластичный эластомер).",
      "Снимает напряжение, улучшает кровообращение и облегчает восстановление после тренировок.",
      "Компактный размер — удобно использовать дома, в офисе и после занятий спортом.",
    ],
  },
  {
    order: true,
    id: 29813438540910,
    title: "Массажный мяч",
    img: "13.52.5198.png",
    desc: "жесткий, 6 см",
    category: "hoop",
    price: 12,
    column: [
      "Профессиональный массажный мяч для йоги и расслабления мышц.",
      "Идеален для массажа стоп и поддержки свода стопы.",
      "Материал: прочный и долговечный TPU (термопластичный полиуретан).",
      "Снимает напряжение, улучшает гибкость и кровообращение.",
      "Компактный и удобный для использования дома, в спортзале или офисе.",
    ],
  },
  {
    order: true,
    id: 2981343875409101,
    title: "Массажный мяч",
    img: "2ea6d7b7-82da-4.png",
    desc: "жесткий, 7 см",
    category: "hoop",
    price: 14,
    column: [
      "Глубокий массажный мяч для расслабления стоп и фасции.",
      "Эффективно снимает напряжение и усталость мышц после нагрузки.",
      "Компактный и портативный — удобно использовать дома, в офисе и в поездках.",
      "Помогает улучшить кровообращение и гибкость стопы.",
      "Идеален для точечного самомассажа и восстановления фасции.",
    ],
  },
  {
    order: true,
    id: 29813438754091012,
    title: "Массажный, легкий мяч",
    img: "1703757746979-df519.webp",
    desc: "для фитнеса",
    category: "hoop",
    price: 8,
    column: [],
  },
  {
    order: true,
    id: 298134387540910129,
    title: "Фитбол / Прочный гимнастический мяч",
    img: "97778.png",
    desc: " 55 см, 800 гр ",
    category: "hoop",
    price: 36,
    column: [],
  },
  {
    order: true,
    id: 2981343875409101291,
    title: "Обруч пластиковый",
    img: "2faa32cd-55b9-11e7-af8d-36376662643807.jpg",
    desc: "50 см",
    category: "hoop",
    price: 12,
    column: [],
  },
  {
    order: true,
    id: 29813438754091012912,
    title: "Обруч пластиковый",
    img: "2faa32d6-55b9-11e7-af8d-36376662643800.jpg",
    desc: "60 см",
    category: "hoop",
    price: 15,
    column: [],
  },
  {
    order: true,
    id: 2989754091012912,
    title: "Обруч - хулахуп массажный с шариками",
    img: "769866.png",
    desc: "96 см",
    category: "hoop",
    price: 52,
    column: [],
  },
  {
    order: true,
    id: 298975409101291230,
    title: "Компрессионные наколенники",
    img: "1834274d-e94e-4281-b81b-043695664120_960x960-Photoroom.png",
    desc: "синий L, синий XXL, черный L, черный XL, серый М",
    category: "kneePads",
    price: 20,
    column: [
      "Компрессионный наколенник AOLIKES — универсальная поддержка для колена.",
      "Подходит для бега, баскетбола, волейбола, йоги, тенниса, футбола и других видов спорта.",
      "Обеспечивает стабильную фиксацию коленного сустава и снижает нагрузку.",
      "Улучшает кровообращение и предотвращает травмы при нагрузках.",
      "Комфортная посадка и дышащий материал для удобного использования.",
    ],
  },
  {
    order: true,
    id: 2989754091012912304,
    title: "Защитный наколенник",
    img: "5db5f83b1e8c4ddc6f073.png",
    desc: "оранжевый M,L,XL / черный М, L, Xl, XXL / зеленый М, L, XL",
    category: "kneePads",
    price: 30,
    column: [
      "Спортивный наколенник с регулируемыми ремнями для надёжной поддержки колена.",
      "Компрессионная защита снижает нагрузку и предотвращает травмы.",
      "Высокоэластичный и дышащий материал — комфорт при длительных тренировках.",
      "Подходит для бега, баскетбола, фитнеса и активных видов спорта.",
    ],
  },
  {
    order: true,
    id: 80910129123045,
    title: "2 компрессионных наколенника",
    img: "a288aabd-266a-.png",
    desc: "зеленый S, синий М, синий L, красный L, серый XL",
    category: "kneePads",
    price: 35,
    column: [
      "Комплект из 2-х эластичных наколенников для повседневного использования и тренировок.",
      "Дышащий и удобный материал обеспечивает тепло и комфорт при носке.",
      "Подходят для фитнеса, работы, активностей и ежедневного использования.",
      "Обеспечивают лёгкую поддержку и согревание коленных суставов.",
    ],
  },
  {
    order: true,
    id: 809101291230454,
    title: "Суппорт локтя, упаковка из 2 шт",
    img: "6037586511.jpg",
    desc: "взрослый",
    category: "kneePads",
    price: 15,
    column: [],
  },
  {
    order: true,
    id: 8091012912304546,
    title: "Суппорт локтя, упаковка из 2 шт",
    img: "6037586511.jpg",
    desc: "детский",
    category: "kneePads",
    price: 15,
    column: [],
  },
];
